import { Col, Flex, Row, Space } from "antd";
import React from "react";
import { HashLink } from "react-router-hash-link";


export default class Footer extends React.Component {

  menus = [
    {
      label: "Home",
      link: "/web"
    },
    {
      label: "pdpa",
      link: "/web/footer/pdpa",
      target: "_blank"
    },
    {
      type: "hash-link",
      label: "destination",
      link: "/web#destinations-highlight"
    },
    // {
    //   label: "privacy policy",
    //   link: "/web/footer/privacy_policy",
    //   target: "_blank"
    // },
    // {
    //   label: "cruises",
    //   link: "/web/cruises"
    // },
    // {
    //   label: "terms & conditions",
    //   link: "/web/footer/terms_and_condition",
    //   target: "_blank"
    // },
    // {
    //   label: "news and events",
    //   link: "/web/blogs?type=news_and_events"
    // },
    {
      label: "",
      link: ""
    },
    // {
    //   label: "corporate",
    //   link: "/web/corporate"
    // },
  ]

  componentDidMount() {
    
  }
  
  render(){
    return (
      <div className="footer">
        {/* <Newsletter/> */}

        <div className="footer_body">
          <Row className="footer_links" gutter={[12, 12]}>
            <Col className="column large-column">
              <Space direction="vertical">
                <div className="link-group-items">
                {
                    this.menus.map((menu, index) => menu.type == "hash-link" ?
                      <HashLink smooth scroll={(el) => el.scrollIntoView({ behavior: 'auto', block: 'end' })} key={index} target={menu.target} to={menu.link}> {menu.label} </HashLink> :
                      <a key={index} target={menu.target} href={menu.link}> {menu.label} </a>
                    )
                  }
                </div>
              </Space>
            </Col>
            <Col className="column small-column">
              <Space direction="vertical">
                <div className="link-group-items">
                  <div><a href="/web/about-us">about us</a></div>
                  <div><a href="/web/contact-us">contact us</a></div>
                  {/* <div><a href="/web/agents">agents</a></div> */}
                </div>
              </Space>
            </Col>
            <Col className="column contact-info small-column">
              <Space direction="vertical" align="center">
                <Flex vertical gap="20px" align="center">
                  {/* <div className="link-group-title">Contact Us</div>
                  <div><a href="/web/contact-agents">contact agents</a></div> */}
                  <div className="link-group-title">Follow us on</div>
                  <Flex gap={20} justify="space-between" className="social-icons">  
                    <a target="_blank" href="https://www.facebook.com/gdgoldendestinations?mibextid=LQQJ4d&rdid=pH2flZqXJ2hEInxM&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2FdyrJrXnkmNiU7ryS%2F%3Fmibextid%3DLQQJ4d#"><img src="/iceholidays-assets/images/social/ico_fb_white.png"/></a>
                    <a target="_blank" href="https://www.youtube.com/@GoldenDestinationsGD"><img src="/iceholidays-assets/images/social/ico_yt_white.png"/></a>
                    {/* <a target="_blank" href="https://wa.me/60128688148"><img src="/iceholidays-assets/images/social/ico_whatsapp.png"/></a> */}
                    <a target="_blank" href="https://www.instagram.com/gdgoldendestinations/?hl=en"><img src="/iceholidays-assets/images/social/ico_ig_white.png"/></a>
                    <a target="_blank" href="https://www.xiaohongshu.com/user/profile/664aaf560000000007007b09?xhsshare=CopyLink&appuid=5ece81090000000001001551&apptime=1723009864&share_id=534e08f2988d425b8466147ee43db45d"><img src="/iceholidays-assets/images/social/xhs_icon.png" style={{height: '18px'}}/></a>
                  </Flex>
                </Flex>
              </Space>
            </Col>
            {/* <Col className="column small-column app-store">
              <Space>
                <a target="_blank" href="/"><img src="/iceholidays-assets/images/social/google_play_icon.png"/></a>
                <a target="_blank" href="https://apps.apple.com/my/app/golden-destinations/id1446862869"><img src="/iceholidays-assets/images/social/app_store_icon.png"/></a>
              </Space>
            </Col> */}
          </Row>
          <div id="copyright">
            <span>Copyright © {(new Date().getFullYear())} Golden Destinations</span>
          </div>
        </div>

      </div>
    ) 
  }
}